import { type BridgeData } from './bridge-data';

/**
 * Subset of {@link BridgeData} used to detect “same database embed” vs navigation to another
 * database or space. Consumed by the bridge Valtio watch and `bridgeDatabaseIdentityChanged`.
 */
export type BridgeIdentitySnapshot = {
  contentId: string;
  contentReferenceId: string;
  spaceId: string;
  spaceKey: string;
};

/**
 * Projects live bridge data onto the four identity fields compared for identity events.
 */
export function pickBridgeIdentitySnapshot(data: BridgeData): BridgeIdentitySnapshot {
  return {
    contentId: data.contentId,
    contentReferenceId: data.contentReferenceId,
    spaceId: data.spaceId,
    spaceKey: data.spaceKey
  };
}

/**
 * True when all four identity fields are strictly equal (primitive `===`).
 */
export function bridgeIdentityEqual(
  a: BridgeIdentitySnapshot,
  b: BridgeIdentitySnapshot
): boolean {
  return (
    a.contentId === b.contentId &&
    a.contentReferenceId === b.contentReferenceId &&
    a.spaceId === b.spaceId &&
    a.spaceKey === b.spaceKey
  );
}
